import { defineStore } from "pinia";

export const useFeedStore = defineStore("feed-store", {
  state: () => ({
    feedGroupId: 0,
    searchedFeeds: [],
    isSearchingFeeds: false,
  }),
  getters: {
  },
  actions: {
    searchFeeds(orgId, searchTerm) {
      this.isSearchingFeeds = true;
      this.apiGet(
        `/feeds/org/${orgId}/search`,
        { search_term: searchTerm },
        data => {
          this.searchedFeeds = data.feeds || [];
          this.isSearchingFeeds = false;
        },
        () => {
          this.searchedFeeds = [];
          this.isSearchingFeeds = false;
        },
      );
    },
    createFeedGroup(name, description, imageUrl, callback) {
      const publicationId = this.publicationId;
      this.apiPost("/feeds/publication/create", {
        publication_id: publicationId,
        name: name,
        description: description,
        image_url: imageUrl || "",
      }, data => {
        if (callback) {
          callback(data);
        }
      });
    },
  },
});
